import TioLoadingSpinner from '../../tio/loading-spinner.gts';

const LoadingRow = <template>
  <div class="grid grid-cols-10 gap-8 p-4 border-b border-gray-200 items-center">
    <div class="col-span-10 flex justify-center py-2">
      <TioLoadingSpinner />
    </div>
  </div>
</template>;

export default LoadingRow;
